/*global document, window */
var bluemoon;
(function (bluemoon) {
    var sessionservices;
    (function (sessionservices) {
        'use strict';
        angular.module('bluemoon-sessionservices-templates', []);
        angular.module('bluemoon.sessionservices', [
            'bluemoon-sessionservices-templates',
            'bluemoon.components',
            'bluemoon.components.session'
        ]);
    })(sessionservices = bluemoon.sessionservices || (bluemoon.sessionservices = {}));
})(bluemoon || (bluemoon = {}));
;var bluemoon;
(function (bluemoon) {
    var sessionservices;
    (function (sessionservices) {
        'use strict';
        angular.module('bluemoon.sessionservices', []);
    })(sessionservices = bluemoon.sessionservices || (bluemoon.sessionservices = {}));
})(bluemoon || (bluemoon = {}));
;var bluemoon;
(function (bluemoon) {
    var sessionservices;
    (function (sessionservices) {
        'use strict';
        var BlueMoonSessionServices = /** @class */ (function () {
            // @ngInject
            BlueMoonSessionServices.$inject = ["$q", "$window"];
            function BlueMoonSessionServices($q, $window) {
                var _this = this;
                this.$q = $q;
                this.$window = $window;
                this.deferAngularService = null;
                this.NgSessionServices = null;
                this.injectAngularService = function (ngSessionServices) {
                    _this.NgSessionServices = ngSessionServices;
                    _this.deferAngularService.resolve(ngSessionServices);
                };
                this.setRoutes = function (routingTable) {
                    _this.deferAngularService.promise.then(function (ngSessionServices) {
                        ngSessionServices.setRoutes(routingTable);
                    });
                };
                this.buildRoute = function (routeBase, route, urlParameters) {
                    if (urlParameters === void 0) { urlParameters = {}; }
                    return _this.NgSessionServices.buildRoute(routeBase, route, urlParameters);
                };
                this.getSessionBindingRoute = function (routeName) {
                    return _this.NgSessionServices.getSessionBindingRoute(routeName);
                };
                this.getProductBindingRoute = function (application, entity, juris) {
                    return _this.NgSessionServices.getProductBindingRoute(application, entity, juris);
                };
                this.getPath = function (serviceName) {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getPath(serviceName).toPromise();
                    });
                };
                this.getProductPath = function (application, entity, juris) {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getProductPath(application, entity, juris).toPromise();
                    });
                };
                this.getPermission = function (frp) {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getPermission(frp).toPromise();
                    });
                };
                this.getDebugMode = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getDebugMode().toPromise();
                    });
                };
                this.getInternalDevMode = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getInternalDevMode().toPromise();
                    });
                };
                this.forceInternalDevMode = function (forceValue) {
                    _this.deferAngularService.promise.then(function (ngSessionServices) {
                        ngSessionServices.forceInternalDevMode(forceValue);
                    });
                };
                this.getEmergingAccounts = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getEmergingAccounts().toPromise();
                    });
                };
                this.getInvoicePermission = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getInvoicePermission().toPromise();
                    });
                };
                this.getTaxCenterPermission = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getTaxCenterPermission().toPromise();
                    });
                };
                this.getApplicationElfPermission = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getApplicationElfPermission().toPromise();
                    });
                };
                this.getApplicationPIIPermission = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.getApplicationPIIPermission().toPromise();
                    });
                };
                this.isFixedAssetsAllowed = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.isFixedAssetsAllowed().toPromise();
                    });
                };
                this.isSetupAllowed = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.isSetupAllowed().toPromise();
                    });
                };
                this.isReturnUnlockedAllowed = function () {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.isReturnUnlockedAllowed().toPromise();
                    });
                };
                this.isProductAllowed = function (entity) {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.isProductAllowed(entity).toPromise();
                    });
                };
                this.isProductYearAllowed = function (year, entity, juris) {
                    return _this.deferAngularService.promise.then(function (ngSessionServices) {
                        return ngSessionServices.isProductYearAllowed(year, entity, juris).toPromise();
                    });
                };
                // strip the domain name by dropping the first 3 segments of a route delimited by '/'
                this.stripDomainName = function (route) {
                    return _this.NgSessionServices.stripDomainName(route);
                };
                this.deferAngularService = $q.defer();
            }
            Object.defineProperty(BlueMoonSessionServices.prototype, "taxServicesRoute", {
                get: function () {
                    return this.NgSessionServices.taxServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "taxCenterServicesRoute", {
                get: function () {
                    return this.NgSessionServices.taxCenterServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "printServicesRoute", {
                get: function () {
                    return this.NgSessionServices.printServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "clientCenterServicesRoute", {
                get: function () {
                    return this.NgSessionServices.clientCenterServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "staffApplicationRoute", {
                get: function () {
                    return this.NgSessionServices.staffApplicationRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "usTaxServicesRoute", {
                get: function () {
                    return this.NgSessionServices.usTaxServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "connectServicesRoute", {
                get: function () {
                    return this.NgSessionServices.connectServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "coreServicesRoute", {
                get: function () {
                    return this.NgSessionServices.coreServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "profileServicesRoute", {
                get: function () {
                    return this.NgSessionServices.profileServicesRoute;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "coreServicesName", {
                get: function () {
                    return this.NgSessionServices.coreServicesName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "taxServicesName", {
                get: function () {
                    return this.NgSessionServices.taxServicesName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "printServicesName", {
                get: function () {
                    return this.NgSessionServices.printServicesName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "connectServicesName", {
                get: function () {
                    return this.NgSessionServices.connectServicesName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "usTaxServicesName", {
                get: function () {
                    return this.NgSessionServices.usTaxServicesName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "udsToken", {
                get: function () {
                    return this.NgSessionServices.udsToken;
                },
                set: function (token) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.udsToken = token;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "companyId", {
                get: function () {
                    return this.NgSessionServices.companyId;
                },
                set: function (companyId) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.companyId = companyId;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "contactId", {
                get: function () {
                    return this.NgSessionServices.contactId;
                },
                set: function (contactId) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.contactId = contactId;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "isTestFirm", {
                get: function () {
                    return this.NgSessionServices.isTestFirm;
                },
                set: function (istestfirm) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.isTestFirm = istestfirm;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "mfaPassed", {
                get: function () {
                    return this.NgSessionServices.mfaPassed;
                },
                set: function (mfapassed) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.mfaPassed = mfapassed;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "staffId", {
                get: function () {
                    return this.NgSessionServices.staffId;
                },
                set: function (staffid) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.staffId = staffid;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "staffUpdatedLast", {
                get: function () {
                    return this.NgSessionServices.staffUpdatedLast;
                },
                set: function (updated) {
                    var _this = this;
                    this.deferAngularService.promise.then(function () {
                        _this.NgSessionServices.staffIpdatedLast = updated;
                    });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(BlueMoonSessionServices.prototype, "routingTable", {
                get: function () {
                    return this.NgSessionServices.routingTable;
                },
                enumerable: false,
                configurable: true
            });
            return BlueMoonSessionServices;
        }());
        sessionservices.BlueMoonSessionServices = BlueMoonSessionServices;
        angular.module('bluemoon.sessionservices').service('BlueMoonSessionServices', BlueMoonSessionServices);
    })(sessionservices = bluemoon.sessionservices || (bluemoon.sessionservices = {}));
})(bluemoon || (bluemoon = {}));
